<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<div class="panel panel-default">
					<div class="panel-heading">
						<h5 class="panel-title">
							<a data-toggle="collapse" href="javascript:void(0);" data-parent="#accordion" data-target="#searchoption"
								>School Admin Attendance</a
							>
						</h5>
					</div>
					<div id="searchoption" class="panel-collapse">
						<div class="panel-body">
							<form class="form-horizontal">
								<div class="col-sm-4">
									<div class="form-group">
										<label class="col-sm-2 control-label">Date:</label>
										<div class="col-sm-4 col-md-4 col-lg-3">
											<p-calendar
												showIcon="true"
												showButtonBar="true"
												(ngModelChange)="onDateChange($event)"
												[(ngModel)]="SelectedDate"
												name="txtDate"
											></p-calendar>
										</div>
									</div>

									<div class="form-group">
										<label class="col-sm-2 control-label">School: </label>
										<div class="col-sm-7 col-md-7 col-lg-6">
											<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="SelectedSchoolID">
                        <option value="" style="display:none;"></option>
                        <option *ngFor="let s of schoolList" [ngValue]="s.SchoolID">{{s.SchoolName}}</option>
                      </select> -->

											<caass-schoolselector [ShowAll]="false"> </caass-schoolselector>
										</div>
									</div>

									<div class="col-sm-8 control-label">
										<button type="button" class="btn btn-primary" (click)="onClickShowReport()">Show Report</button>
										<div *ngIf="loadingInstructorTable">
											<strong>Loading School Admin Attendance Report, Please wait..!</strong>
										</div>
									</div>
								</div>

								<div *ngIf="showFilters">
									<div class="col-sm-4">
										<div class="form-group">
											<label class="col-sm-2 control-label">Sort By:</label>
											<div class="col-sm-6 col-md-6 col-lg-5">
												<select
													class="form-control"
													name="SortByID"
													(ngModelChange)="onSortByChange($event)"
													[(ngModel)]="SelectedSortByID"
												>
													<option value="" style="display: none"></option>
													<option *ngFor="let sB of SortByList" [ngValue]="sB.SortByID">
														{{ sB.SortByDesc }}
													</option>
												</select>
											</div>
										</div>

										<div class="form-group">
											<label class="col-sm-2 control-label">Filter By Attendance Status:</label>
											<div class="col-sm-6 col-md-6 col-lg-5">
												<select
													class="form-control"
													name="StatusID"
													(ngModelChange)="onAStatusChange($event)"
													[(ngModel)]="SelectedStatusID"
												>
													<option value="" style="display: none"></option>
													<option *ngFor="let aS of AStatusList" [ngValue]="aS.StatusID">
														{{ aS.StatusDesc }}
													</option>
												</select>
											</div>
										</div>
										<div class="form-group">
											<label class="col-sm-2 control-label">Percentage to date:</label>
											<div class="col-sm-10 col-md-10 col-lg-9">
												<h4
													[ngStyle]="{
														color: 'blue'
													}"
												>
													{{ attendancePercentage }}%
												</h4>
											</div>
										</div>
									</div>

									<div class="col-sm-4">
										<div class="form-group">
											<label class="col-sm-2 control-label">Filter By Period: </label>
											<div class="col-sm-6 col-md-6 col-lg-5">
												<select
													class="form-control"
													name="Period"
													(ngModelChange)="onPeriodChange($event)"
													[(ngModel)]="SelectedPeriod"
												>
													<option value="" style="display: none"></option>
													<option *ngFor="let p of periodList" [ngValue]="p">
														{{ p }}
													</option>
												</select>
											</div>
										</div>
										<div class="form-group">
											<label class="col-sm-2 control-label">Filter By Instructor: </label>
											<div class="col-sm-6 col-md-6 col-lg-5">
												<select
													class="form-control"
													name="Instructor"
													(ngModelChange)="onInstructorChange($event)"
													[(ngModel)]="SelectedInstructor"
												>
													<option value="" style="display: none"></option>
													<option *ngFor="let i of instructorList" [ngValue]="i">
														{{ i }}
													</option>
												</select>
											</div>
										</div>
										<div class="form-group">
											<label class="col-sm-2 control-label">Filter By Course: </label>
											<div class="col-sm-6 col-md-6 col-lg-5">
												<select
													class="form-control"
													name="CourseDesc"
													(ngModelChange)="onCourseChange($event)"
													[(ngModel)]="SelectedCourse"
												>
													<option value="" style="display: none"></option>
													<option *ngFor="let c of courseList" [ngValue]="c">
														{{ c }}
													</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="showInstructorTable">
	<div class="table table-striped">
		<table class="table table-striped table-bordered dataTable">
			<thead>
				<tr>
					<th width="5.5%">Time</th>
					<th width="8.5%">Instructor</th>
					<th width="5.5%">Period</th>

					<th width="6.5%">Status</th>
					<th width="5.5%">Section</th>
					<th width="10.5%">Course Code</th>
					<th width="11.5%">Course Description</th>
					<th width="5.0%">Percentage of present</th>
					<th width="5.0%">Class count</th>
					<th width="5.0%">Present</th>
					<th width="5.0%">Absent</th>
					<th width="5.0%">Release</th>
					<th width="5.0%">Tardy</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let Ins of sortedByList">
					<td class="filterable-cell" width="5.5%">
						{{ Ins.Time | date : "shortTime" }}
					</td>
					<td class="filterable-cell" width="8.5%">
						{{ Ins.InstructorName }}
					</td>
					<td class="filterable-cell" width="5.6%">
						{{ Ins.Period }}
					</td>

					<td
						class="filterable-cell"
						width="6.6%"
						[ngStyle]="{
							color: Ins?.AStatus === 'Not Taken' ? 'red' : 'green'
						}"
						(click)="pullStudents(Ins.ClassAttendanceID)"
					>
						{{ Ins.AStatus }}
						<div *ngIf="showStudentList && selectedAttendanceID == Ins.ClassAttendanceID">
							<button *ngIf="showStudentList" type=" button" id="myBtn">View Info.</button>
							<div class="container" [ngStyle]="{ color: 'black' }">
								<!-- Trigger the modal with a button -->

								<!-- Modal -->
								<div class="modal fade" id="myModal" role="dialog">
									<div class="modal-dialog">
										<!-- Modal content-->
										<div class="modal-content">
											<div class="modal-header">
												<button type="button" class="close" data-dismiss="modal">&times;</button>
												<h4 class="modal-title">View Attendance Details</h4>
											</div>
											<div class="modal-body">
												<div id="searchoption" class="panel-collapse">
													<label>Instructor: </label>
													{{ InstructorSelected }}
													<div class="panel-body"></div>
													<div
														[ngStyle]="{
															color: 'black'
														}"
													>
														<table class="table table-striped">
															<thead>
																<tr>
																	<th width="12%">Student ID</th>
																	<th width="20%">Student Name</th>
																	<th width="34%">ClassAttendanceStatusDesc</th>
																	<th width="20%">EntryTime</th>
																</tr>
															</thead>
															<tbody>
																<tr *ngFor="let std of studentsDetail">
																	<td width="12%">
																		{{ std.StudentID }}
																	</td>
																	<td width="20%">
																		{{ std.StudentName }}
																	</td>
																	<td width="34%">
																		{{ std.ClassAttendanceStatusDesc }}
																	</td>
																	<td width="20%">
																		{{ std.EntryTime | date : "shortTime" }}
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</div>
											<div class="modal-footer">
												<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</td>
					<td class="filterable-cell" width="5.6%">
						{{ Ins.Section }}
					</td>
					<td class="filterable-cell" width="10.6%">
						{{ Ins.Course }}
					</td>
					<td class="filterable-cell" width="11.6%">
						{{ Ins.CourseDesc }}
					</td>
					<td class="filterable-cell" width="5.1%">
						{{ Ins.Percentage }}
					</td>
					<td class="filterable-cell" width="5.1%">
						{{ Ins.Total }}
					</td>
					<td class="filterable-cell" width="5.1%">
						{{ Ins.Present }}
					</td>
					<td class="filterable-cell" width="5.1%">
						{{ Ins.Absent }}
					</td>
					<td class="filterable-cell" width="5.1%">
						{{ Ins.Release }}
					</td>
					<td class="filterable-cell" width="5.1%">
						{{ Ins.Tardy }}
					</td>
					{{
						Ins.ClassAttendaceID
					}}
				</tr>
			</tbody>
		</table>
	</div>
</div>
